import normGraphqlRequest from './normGraphqlRequest';
import { 
  PERIOD_SCORE_MAP_QUERY, 
  StandardCalendarNormDataInput, 
  PeriodScoreMapResponse 
} from './graphql/queries/normQueries';

/**
 * Service for interacting with the Norm Service API
 */
export class NormService {
  /**
   * Get period score map data from the Norm Service
   * @param input - The input parameters for the period score map query
   * @returns Promise resolving to the period score map response
   */
  static async getPeriodScoreMap(input: StandardCalendarNormDataInput): Promise<PeriodScoreMapResponse> {
    try {
      const response = await normGraphqlRequest<PeriodScoreMapResponse>(
        PERIOD_SCORE_MAP_QUERY,
        { input }
      );
      return response;
    } catch (error) {
      console.error('Error fetching period score map:', error);
      throw error;
    }
  }
}

export default NormService; 